import { useWarmUpBankToken } from "Api/Mutations/Accounts/useWarmUpBankToken";
import { useCallback, useEffect, useRef } from "react";

/**
 * Pre-fetches the bank token for the account the customer is about to pay from, so the pay request finds it
 * cached and skips the refresh round trip (0.2–1 s depending on the bank). Runs once for the preselected account
 * and again whenever the customer switches account; each account is warmed only once per screen — its token
 * lives minutes and the pay request refreshes it itself if it still expired.
 */
export const usePayAccountWarmUp = (initialBankAccountPublicID?: string) => {
  const warmedAccounts = useRef(new Set<string>());
  const { mutate } = useWarmUpBankToken();

  const warmUp = useCallback(
    (bankAccountPublicID?: string) => {
      if (
        !bankAccountPublicID ||
        warmedAccounts.current.has(bankAccountPublicID)
      ) {
        return;
      }
      warmedAccounts.current.add(bankAccountPublicID);
      mutate(bankAccountPublicID);
    },
    [mutate],
  );

  useEffect(() => {
    warmUp(initialBankAccountPublicID);
  }, [warmUp, initialBankAccountPublicID]);

  return { onBankAccountChange: warmUp };
};
